import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';

export default class Translation extends Component {

	static propTypes = {
        identifier: PropTypes.string,
		translation: PropTypes.object.isRequired,
		update: PropTypes.func.isRequired,
		setHasUnsavedChanges: PropTypes.func.isRequired,
		lockedBy: PropTypes.any,
		languageIndex: PropTypes.number,
		defaultValueVariables: PropTypes.array,
		noValue: PropTypes.bool,
		allowMultiline: PropTypes.bool,
		isSelected: PropTypes.bool,
		updateSelected: PropTypes.func,
        focusTranslation: PropTypes.string,
        updateFocusTranslation: PropTypes.func,
        disabled: PropTypes.bool
	};

	constructor(props) {
		super(props);

		this.state = {
			translation: Translation.getCurrentValueOf(props.translation),
            hasFocus: false
		};
	}

	static getCurrentValueOf(translation) {
		return translation.newValue === '' ? translation.value : translation.newValue;
	}

	componentWillReceiveProps(nextProps, nextContext) {
		if (nextProps.translation.value !== this.props.translation.value) {
			this.setState({translation: Translation.getCurrentValueOf(nextProps.translation)})
		}
	}

	updateTranslation(value) {
		if (this.props.translation.newValue === '')
		{
			this.props.setHasUnsavedChanges(false);
		}else {
			this.props.setHasUnsavedChanges(this.props.translation.newValue !== value);
		}
		this.setState({translation: value});
	}

	saveTranslation() {
		if (this.state.translation !== Translation.getCurrentValueOf(this.props.translation)) {
			this.props.update(this.state.translation)
				.then(this.props.setHasUnsavedChanges(false));
		}
	}

	translationHasBeenUpdated() {
		return (
			this.props.translation.newValue !== this.state.translation ?
				this.state.translation :
				this.props.translation.newValue
		) !== this.props.translation.value;
	}

	render() {
		return (
			<Fragment>
				<textarea
					onKeyPress={(event) => {
						if(event.charCode === 13 && this.props.allowMultiline === false) {
							event.preventDefault();
							return false;
						}
					}}
					rows={1}
					tabIndex={this.props.languageIndex + 1}
					className={(this.props.noValue === false && this.state.translation === '' ? 'empty-translation' : '') + (this.props.lockedBy === true?' resizeTranslation ' + (this.props.identifier === this.props.focusTranslation?'resizeTranslationFocus':''):'') + ' form-control p-0'}
					value={this.state.translation}
					onChange={e => this.updateTranslation(this.props.allowMultiline===true?e.target.value:e.target.value.replace(/(\r\n|\n|\r)/gm, " "))}
					onBlur={() => this.saveTranslation()}
					readOnly={this.props.lockedBy !== true}
					onFocus={() => {this.props.updateSelected(); this.props.updateFocusTranslation(this.props.identifier)}}
                    disabled={this.props.disabled}
				/>
				{
					this.translationHasBeenUpdated() ?
						<span className="oldValue">old value: "{this.props.translation.value}"</span> : null
				}
				{
					this.props.lockedBy === true ? this.props.defaultValueVariables.map((value, index) => {
						if (!this.state.translation.includes(value)) {
							return <div className="alert alert-primary fade show" key={index}>Missing
								variable {value}</div>;
						}
						return null;
					}) : null
				}
			</Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./React/src/components/Translation.js